import React from 'react';
import {
  appTell,
  isCsairApp,
  gspUpgrades,
  gspNewVersion,
} from '@csair/emp-helpers';
import customerService from './assets/customer_service.png';
import customerService2 from './assets/customer_service2.png';
import './index.less';

export function BaseLayout({ children, className }) {
  return (
    <div id="wrapper" className={`wrapper ${className || ''}`}>
      {children}
    </div>
  );
}

export function CustomerService() {
  function handleClickCallPhone() {
    gspNewVersion(
      window.location.hash.indexOf('orderType=S') > -1
        ? ['变更详情页-返回首页-按钮', '072-0050-23028-12201']
        : ['退票详情页-返回首页-按钮', '072-0053-23028-12201'],
      {
        1: '点击一次触发一次',
        2: '国双新版',
        3: isCsairApp() ? 'App' : 'Mobile',
      }
    );
    isCsairApp() ? appTell('95539') : (window.location.href = 'tel://95539');
  }

  return (
    <a
      role="button"
      href="javascript:void(0)"
      onClick={handleClickCallPhone}
      className="customerService"
    >
      <img alt="" src={customerService2} />
      {/* <span className="customer_Label">客服</span> */}
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/components/Widgets/index.js